import React, { useState } from "react";
import qr from "../../../assets/icons/qr.png";
import { Radio } from "antd";
const PaymentMethod = ({ plan, operator, mob }) => {
  const [selectedMethod, setSelectedMethod] = useState("UPI");

  return (
    <div className="payment-summary-container">
      {/* Left Section - Payment Method */}
      <div className="payment-method w45">
        <h3>Payment method</h3>
        <div className="payment-options">
          <label
            className={`payment-option ${
              selectedMethod === "UPI" ? "active" : ""
            }`}
            onClick={() => setSelectedMethod("UPI")}
          >
            <Radio name="payment" checked={selectedMethod === "UPI"} readOnly />
            UPI
          </label>
          <label
            className={`payment-option ${
              selectedMethod === "Debit Card" ? "active" : ""
            }`}
            onClick={() => setSelectedMethod("Debit Card")}
          >
            <Radio name="payment" checked={selectedMethod === "Debit Card"} />
            Debit card
          </label>
          <label
            className={`payment-option ${
              selectedMethod === "Account" ? "active" : ""
            }`}
            onClick={() => setSelectedMethod("Account")}
          >
            <Radio name="payment" checked={selectedMethod === "Account"} />
            Account
          </label>
        </div>

        {/* QR Code Section for UPI */}
        {selectedMethod === "UPI" && (
          <>
            <div className="qr-section">
              <p className="mb1">Scan QR to pay</p>
              <img src={qr} alt="QR Code" className="qr-code" />
            </div>
            <br />
            <br />
            <p className="note">
              Please ensure your pop-up blocker is disabled for our site to
              ensure a smooth payment process. This can typically be done by
              clicking the pop-up blocker icon in your browser’s address bar and
              selecting “Enable pop-ups for this site.”
            </p>
          </>
        )}

        {selectedMethod === "Debit Card" && (
          <div className="payment-container">
            <h2 className="title">Debit card</h2>

            <div className="warning-box">
              <span className="warning-icon">⚠️</span>
              Kindly check your debit card online transaction limit before
              initiating the payment.
            </div>

            <div className="label mb1">Card information</div>
            <input
              type="text"
              className="input-field top"
              placeholder="1234 1234 1234 1234"
              maxlength="19"
            />

            <div className="card-details">
              <input
                type="text"
                className="input-field left"
                placeholder="MM / YY"
                maxlength="5"
              />
              <input
                type="text"
                className="input-field right"
                placeholder="CVV"
                maxlength="3"
              />
            </div>

            <button className="send-btn mt3">Pay ₹19.00</button>
          </div>
        )}
      </div>

      {/* Right Section - Payment Summary */}
      <div className="plan-summary-details w40">
        <div className="plan-header">
          <div className="d-flex align-center gap1">
            <div className="plan-logo">
              <img src={operator?.icon} alt="Jio Logo" />
            </div>
            <div className="plan-info">
              <h4>{operator?.label}</h4>
              <p>+91 {mob}</p>
            </div>
          </div>
          <div className="bill-amount">
            <span>Bill Amount </span>
            <span>₹ {plan?.price}</span>
          </div>
        </div>
        <hr />
        <div className="summary-details">
          <div className="summary-item">
            <span>Bill Amount</span>
            <span>₹ {plan?.price}</span>
          </div>
          <div className="summary-item">
            <span>Platform Fee</span>
            <span>₹ 0.00</span>
          </div>
          <hr />
          <div className="summary-item total">
            <span>Total Payable Amount</span>
            <span>₹ {plan?.price}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentMethod;
